import { SecretValue } from "client/Api/Apps/common";
import { environmentHttpClient } from "client/Api/httpClient";

export enum UserIdKind {
	EmailAddress = 0,
	UserPrincipalName = 1
};

export type ZenyaConnectionModel = {
	id: number;
	name: string;
	userIdKind: UserIdKind;
	serverUrl: string;
};

export type ZenyaConnectionListItemModel = {
	id: number;
	name: string;
	serverUrl: string;
	userIdKind: UserIdKind;
};

export type ZenyaConnectionSaveModel = {
	name: string;
	userIdKind: UserIdKind;
	serverUrl: string;
	apiKey: SecretValue;
};

export type NewConnectionZenyaSaveResultModel = {
	connectionId: number;
};

export function list(
	signal?: AbortSignal
): Promise<ReadonlyArray<ZenyaConnectionListItemModel>> {
	return environmentHttpClient.get<ReadonlyArray<ZenyaConnectionListItemModel>>(
		"UiApi/ZenyaConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal?: AbortSignal
): Promise<ZenyaConnectionModel> {
	return environmentHttpClient.get<ZenyaConnectionModel>(
		`UiApi/ZenyaConfiguration/${id}`,
		undefined,
		{
			signal
		}
	);
}

export function create(model: ZenyaConnectionSaveModel, signal?: AbortSignal): Promise<NewConnectionZenyaSaveResultModel> {
	return environmentHttpClient.post<NewConnectionZenyaSaveResultModel>(
		"UiApi/ZenyaConfiguration",
		model,
		{ signal }
	);
}

export function update(
	id: number,
	model: ZenyaConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		`UiApi/ZenyaConfiguration/${id}`,
		model,
		{ signal }
	);
}

export function deleteMultiple(
	ids: ReadonlyArray<number>,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		"UiApi/ZenyaConfiguration",
		ids,
		{ signal }
	);
}
